<template>
  <div class="quote-widget">
    <div @click="openDialog">
      <div v-if="quote === null">
        <v-layout row>
          <v-flex xs12 class="text-xs-center" align-self-center>
            <p>{{ $t('widgets.quotes.loading') }}</p>
          </v-flex>
        </v-layout>
      </div>
      <div v-else>
        <p>{{ quote }}</p>
        <p v-if="author" class="caption">- {{ author }}</p>
      </div>
    </div>
    <div class="remove-btn clock">
      <remove-button :widget-position="currentWidget" :widget-name="widgetName" />
    </div>
    <v-dialog v-model="dialog" scrollable max-width="500" dark>
      <widgetForm
        :show-form="showForm"
        :widget-schema="formSchema"
        :widget-values="formValues"
        :widget-name="widgetName"
        :widget-position="currentWidget"
        @closeDialog="closeDialog"
      />
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import WidgetForm from '../../components/Forms/widgetForm'
import RemoveButton from '../../components/Buttons/RemoveButton'

const corsAny = 'https://cors-anywhere.herokuapp.com/'
const frted = 'https://api.fatherted.irish/quotes/random'
const famous = 'https://quote-garden.herokuapp.com/api/v2/quotes/random'
const drump = 'https://tronalddump.io/random/quote'
const dadJokes = 'https://icanhazdadjoke.com/'
const chucknorris = 'https://api.chucknorris.io/jokes/random'

export default {
  name: 'Quotes',
  components: {
    WidgetForm,
    RemoveButton
  },
  props: {
    widgetData: {
      type: Object,
      required: false
    },
    widgetName: {
      type: String,
      required: true
    },
    paidPlan: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      loading: true,
      dialog: false,
      showForm: false,
      quote: null,
      quoteTopic: this.widgetData.quoteTopic,
      updateEvery: this.widgetData.updateEvery,
      author: null,
      currentWidget: this.$attrs.position,
      formValues: {},
      formSchema: {}
    }
  },
  computed: {
    /* Create defaults for this widget */
    useData() {
      return (
        this.widgetData || {
          quoteTopic: 'frted'
        }
      )
    },
    getCurrentLang() {
      return this.$i18n.locale
    }
  },
  watch: {
    widgetData: {
      handler(newVal, oldVal) {
        if (
          (newVal && newVal.quoteTopic !== oldVal.quoteTopic) ||
          (newVal && newVal.updateEvery !== oldVal.updateEvery)
        ) {
          this.quoteTopic = newVal.quoteTopic
          this.updateEvery = newVal.updateEvery
          this.quote = null
          this.author = null
          this.getQuotes()
        }
      },
      deep: true
    }
  },
  mounted() {
    this.getQuotes()
  },
  beforeDestroy() {
    clearInterval(this.$options.quote_interval)
  },
  methods: {
    openDialog() {
      this.dialog = true
      this.setFormSchema()
      this.setFormValues()
      this.showForm = true
    },
    closeDialog() {
      this.dialog = false
      this.showForm = false
      this.setFormValues()
      this.formSchema = {}
    },
    setFormSchema() {
      const formSchema = {
        quoteTopic: {
          type: 'radio',
          label: this.$i18n.t('widgets.quotes.form.topic'),
          options: [
            {
              label: 'Fr. Ted',
              value: 'frted'
            },
            {
              label: this.$i18n.t('widgets.quotes.form.options.dadJokes'),
              value: 'dadjokes'
            },
            {
              label: this.$i18n.t('widgets.quotes.form.options.chuckNorris'),
              value: 'chucknorris'
            },
            {
              label: this.$i18n.t('widgets.quotes.form.options.famous'),
              value: 'famous'
            },
            {
              label: this.$i18n.t('widgets.quotes.form.options.drump'),
              value: 'drump'
            }
          ],
          flex: 12
        },
        updateEvery: {
          type: 'select',
          label: this.$i18n.t('widgets.weather.form.updateEvery'),
          items: [
            { text: this.$i18n.t('time.freq.30sec'), value: 30000 },
            { text: this.$i18n.t('time.freq.1min'), value: 60000 },
            { text: this.$i18n.t('time.freq.5min'), value: 300000 },
            { text: this.$i18n.t('time.freq.10min'), value: 600000 },
            { text: this.$i18n.t('time.freq.30min'), value: 180000 },
            { text: this.$i18n.t('time.freq.1h'), value: 360000 },
            { text: this.$i18n.t('time.freq.3h'), value: 1080000 }
          ],
          flex: 12
        }
      }
      this.formSchema = formSchema
    },
    setFormValues() {
      this.formValues.quoteTopic = this.useData.quoteTopic || 'frted'
      this.formValues.updateEvery = this.useData.updateEvery || 60000
    },
    getQuotes() {
      clearInterval(this.$options.quote_interval)
      if (this.quoteTopic === 'frted') {
        this.getTedQuote()
        this.$options.quote_interval = setInterval(
          this.getTedQuote,
          this.updateEvery
        )
      }
      if (this.quoteTopic === 'famous') {
        this.getFamousQuote()
        this.$options.quote_interval = setInterval(
          this.getFamousQuote,
          this.updateEvery
        )
      }
      if (this.quoteTopic === 'drump') {
        this.getDrumpQuote()
        this.$options.quote_interval = setInterval(
          this.getDrumpQuote,
          this.updateEvery
        )
      }
      if (this.quoteTopic === 'dadjokes') {
        this.getDadJokes()
        this.$options.quote_interval = setInterval(
          this.getDadJokes,
          this.updateEvery
        )
      }
      if (this.quoteTopic === 'chucknorris') {
        this.getChuck()
        this.$options.quote_interval = setInterval(
          this.getChuck,
          this.updateEvery
        )
      }
    },
    getTedQuote() {
      axios.get(corsAny + frted, {}).then(response => {
        this.quote = response.data.quote
        this.author = null
      })
      this.loading = false
    },
    getFamousQuote() {
      axios.get(corsAny + famous, {}).then(response => {
        this.quote = response.data.quote.quoteText
        this.author = response.data.quote.quoteAuthor
      })
      this.loading = false
    },
    getDrumpQuote() {
      axios.get(corsAny + drump, {}).then(response => {
        this.quote = response.data.value
        this.author = 'Donald Trump really said this'
      })
      this.loading = false
    },
    getChuck() {
      axios.get(corsAny + chucknorris, {}).then(response => {
        this.quote = response.data.value
        this.author = null
      })
      this.loading = false
    },
    getDadJokes() {
      axios
        .get(dadJokes, {
          headers: {
            // eslint-disable-next-line
            'Accept': 'application/json',
            'User-Agent': 'Saga Dashboard (https://sagadash)'
          }
        })
        .then(response => {
          this.quote = response.data.joke
          this.author = null
        })
      this.loading = false
    },
    removeWidget() {
      this.dialog = false
      this.$store.dispatch('dashboard/updateWidgetType', {
        [this.currentWidget]: 'blank'
      })
    }
  }
}
</script>

<style lang="scss">
.quote-widget {
  .remove-btn {
    text-align: center;
    font-size: 12px;
    transition: 0s;
    opacity: 0;
    &.quotes {
      position: relative;
      top: -20px;
    }
  }
  &:hover {
    cursor: pointer;
    .remove-btn {
      opacity: 0.8;
      transition-delay: 1.5s;
      text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.4);
    }
  }
}
</style>
